export default "__VITE_ASSET__Ck6yjYVM__"